// TenantSettingsBar.tsx
import { Button } from '@/components/shared/button/Button';
import React from 'react';
import { MdExitToApp } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import strings from './tenantManagement.translations';

interface TenantSettingsBarProps {
  tenantId: string; // ID of the tenant being managed
  onClose: () => void; // Callback to close the bar
  tenantName?: string; // Optional: display name if already available
}

export const TenantSettingsBar: React.FC<TenantSettingsBarProps> = ({ tenantId, tenantName, onClose }) => {
  const navigate = useNavigate();

  // Do not render the bar if no tenantId
  if (!tenantId) return null;

  // Exit handler calls onClose callback
  const exitSettings = () => {
    onClose();
    navigate('/', { replace: true });
  };

  return (
    <div className="bg-secondary-500 text-white px-4 py-2 flex justify-between items-center">
      {/* Display the name of the tenant being managed */}
      <span>{strings.tenantSettingsBar.editingTenant(tenantName ?? tenantId)}</span>

      {/* Exit settings button */}
      <Button onClick={exitSettings} className="flex items-center gap-1">
        <MdExitToApp size={16} />
        {strings.tenantSettingsBar.exit}
      </Button>
    </div>
  );
};
